import * as React from 'react';
import styled from 'styled-components';
import {mobileMediaQuery} from '../../styles';

const WatchButton = props => {
    if (props.to.length <= 1) {
        return (
            <WrappedLink
                href={props.to[0]}
                backgroundColor={props.backgroundColor}
                target="_blank"
            >
                {props.image && <img src={props.image} alt={props.title} />}
                {props.title && <Title>{props.title}</Title>}
                <Spacer />
                <Subtitle color={props.subtitleColor}>
                    {props.subtitle}
                </Subtitle>
                {props.rightImages && (
                    <Chevron
                        src={props.rightImages[0]}
                        color={props.subtitleColor}
                    />
                )}
            </WrappedLink>
        );
    } else {
        //link on the image only
        return (
            <BasicContainer backgroundColor={props.backgroundColor}>
                {props.image && <img src={props.image} alt={props.title} />}
                {props.title && <Title>{props.title}</Title>}
                <Spacer />
                <Subtitle color={props.subtitleColor}>
                    {props.subtitle}
                </Subtitle>
                {props.rightImages &&
                    props.rightImages.map((image, index) => {
                        return (
                            <a href={props.to[index]}>
                                <Chevron
                                    src={image}
                                    color={props.subtitleColor}
                                    key={String(index)}
                                />
                            </a>
                        );
                    })}
            </BasicContainer>
        );
    }
};

const Title = styled.div`
    font-family: Oduda;
    font-weight: 700;
    font-size: 16px;
    color: black;
    flex-grow: 1;
`;

const Subtitle = styled.div`
    font-family: Oduda;
    font-size: 16px;
    color: ${props => props.color};
    text-transform: uppercase;
`;

const Chevron = styled.img`
    align-self: center;

    margin-left: 18px;
`;

const Spacer = styled.div`
    flex-grow: 1;
`;

const WrappedLink = styled.a`
    background-color: ${props => props.backgroundColor};
    border-radius: 8px;
    height: 54px;
    width: 505px;
    flex-direction: row;
    display: flex;
    align-items: center;
    padding: 0px 13px;
    margin-bottom: 24px;
    color: transparent;

    ${mobileMediaQuery} {
        width: calc(100% - 32px - 26px);
    }
`;

const BasicContainer = styled.div`
    background-color: ${props => props.backgroundColor};
    border-radius: 8px;
    height: 54px;
    width: 505px;
    flex-direction: row;
    display: flex;
    align-items: center;
    padding: 0px 13px;
    margin-bottom: 24px;
    color: transparent;

    ${mobileMediaQuery} {
        width: calc(100% - 32px - 26px);
    }
`;

export default WatchButton;
